<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs v-model="common_tab" vertical>
            <v-tab v-if="!visibleTaskPanel">Задачи <v-chip v-if="tasks.whom.length>0" class="ml-1" color="red" small>{{ tasks.whom.length }}</v-chip></v-tab>
            <v-tab v-if="!visibleProjectPanel">Проекты <v-chip v-if="projects.whom.length>0" class="ml-1" color="red" small>{{ projects.whom.length }}</v-chip></v-tab>
            <v-tab v-if="!visibleTicketPanel">Заявки <v-chip v-if="ticket.whom.length>0" class="ml-1" color="red" small>{{ ticket.whom.length }}</v-chip></v-tab>
            <v-tab-item v-if="!visibleTaskPanel">
              <v-card flat>
                <v-tabs v-model="task_tab" background-color="grey lighten-2">
                  <v-tab v-if="tasks.whom.length>0">Требует обработки <v-chip class="ml-1" color="red" outlined small>{{ tasks.whom.length }}</v-chip></v-tab>
                  <v-tab v-if="tasks.customer.length>0">Я назначил(а) <v-chip class="ml-1" color="red" outlined small>{{ tasks.customer.length }}</v-chip></v-tab>
                  <v-tab v-if="tasks.executor.length>0">Мне назначили <v-chip class="ml-1" color="red" outlined small>{{ tasks.executor.length }}</v-chip></v-tab>
                  <v-tab v-if="tasks.watcher.length>0">Я наблюдатель <v-chip class="ml-1" color="red" outlined small>{{ tasks.watcher.length }}</v-chip></v-tab>

                  <v-tab-item v-if="tasks.whom.length>0">
                    <v-data-table :headers="headers_task" :items="tasks.whom" dense @click:row="clickTask" :item-class="expiredTask" :items-per-page="10">
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriority(item.priority).color" dark small>
                          {{ getPriority(item.priority).name }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item v-if="tasks.customer.length>0">
                    <v-data-table :headers="headers_task_exe" :items="tasks.customer" dense @click:row="clickTask" :item-class="expiredTask" :items-per-page="10">
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriority(item.priority).color" dark small>
                          {{ getPriority(item.priority).name }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item v-if="tasks.executor.length>0">
                    <v-data-table :headers="headers_task" :items="tasks.executor" dense @click:row="clickTask" :item-class="expiredTask" :items-per-page="10">
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriority(item.priority).color" dark small>
                          {{ getPriority(item.priority).name }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item v-if="tasks.watcher.length>0">
                    <v-data-table :headers="headers_task" :items="tasks.watcher" dense @click:row="clickTask" :item-class="expiredTask" :items-per-page="10">
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriority(item.priority).color" dark small>
                          {{ getPriority(item.priority).name }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!visibleProjectPanel">
              <v-card flat>
                <v-tabs v-model="prj_tab" background-color="grey lighten-2">
                  <v-tab v-if="projects.whom.length>0">Требует внимания <v-chip class="ml-1" color="red" outlined small>{{ projects.whom.length }}</v-chip></v-tab>
                  <v-tab v-if="projects.customer.length>0">Я заказчик <v-chip class="ml-1" color="red" outlined small>{{ projects.customer.length }}</v-chip></v-tab>
                  <v-tab v-if="projects.executor.length>0">Я РП <v-chip class="ml-1" color="red" outlined small>{{ projects.executor.length }}</v-chip></v-tab>
                  <v-tab v-if="projects.participate.length>0">Участвую <v-chip class="ml-1" color="red" outlined small>{{ projects.participate.length }}</v-chip></v-tab>
                  <v-tab v-if="projects.sub.length>0">Сотрудники <v-chip class="ml-1" color="red" outlined small>{{ projects.sub.length }}</v-chip></v-tab>
                  <v-tab-item v-if="projects.whom.length>0">
                    <v-data-table
                      :headers="headers_prj"
                      :items="projects.whom"
                      :items-per-page="10"
                      dense
                      :item-class="expiredTask"
                      @click:row="clickProject"
                    >
                      <template v-slot:item.name="{ item }">
                        <span v-html="item.name"/>
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item v-if="projects.customer.length>0">
                    <v-data-table
                      :headers="headers_prj_customer"
                      :items="projects.customer"
                      :items-per-page="10"
                      dense
                      :item-class="expiredTask"
                      @click:row="clickProject"
                    />
                  </v-tab-item>
                  <v-tab-item v-if="projects.executor.length>0">
                    <v-data-table
                      :headers="headers_prj"
                      :items="projects.executor"
                      :items-per-page="10"
                      dense
                      :item-class="expiredTask"
                      @click:row="clickProject"
                    />
                  </v-tab-item>

                  <v-tab-item v-if="projects.participate.length>0">
                    <v-data-table
                      :headers="headers_prj"
                      :items="projects.participate"
                      :items-per-page="10"
                      dense
                      :item-class="expiredTask"
                      @click:row="clickProject"
                    />
                  </v-tab-item>

                  <v-tab-item v-if="projects.sub.length>0">
                    <v-data-table
                      :headers="headers_prj_sub"
                      :items="projects.sub"
                      :items-per-page="10"
                      dense
                      :item-class="expiredTask"
                      @click:row="clickProject"
                    >
                      <template v-slot:item.members="{ item }">
                        <span v-for="(member, idx) in item.members" :key="idx">
                          {{ member }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!visibleTicketPanel">
              <v-card flat>
                <v-tabs v-model="ticket_tab" background-color="grey lighten-2">
                  <v-tab v-if="ticket.whom.length>0">Требует обработки <v-chip class="ml-1" color="red" outlined small>{{ ticket.whom.length }}</v-chip></v-tab>
                  <v-tab v-if="ticket.executor.length>0">Я руководитель <v-chip class="ml-1" color="red" outlined small>{{ ticket.executor.length }}</v-chip></v-tab>
                  <v-tab v-if="ticket.watcher.length>0">Я наблюдатель <v-chip class="ml-1" color="red" outlined small>{{ ticket.watcher.length }}</v-chip></v-tab>
                  <v-tab-item v-if="ticket.whom.length>0">
                    <v-data-table
                      :headers="header_ticket"
                      :items="ticket.whom"
                      :items-per-page="10"
                      dense
                      @click:row="clickTicket"
                    >
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriorityTicket(item.priority).color" dark small>
                          {{ getPriorityTicket(item.priority).name }}
                        </v-chip>
                      </template>
                      <template v-slot:item.whom="{ item }">
                        {{ getWhom(item) }}
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item v-if="ticket.executor.length>0">
                    <v-data-table
                      :headers="header_ticket"
                      :items="ticket.executor"
                      :items-per-page="10"
                      dense
                      @click:row="clickTicket"
                    >
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriorityTicket(item.priority).color" dark small>
                          {{ getPriorityTicket(item.priority).name }}
                        </v-chip>
                      </template>
                      <template v-slot:item.whom="{ item }">
                        {{ getWhom(item) }}
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item v-if="ticket.watcher.length>0">
                    <v-data-table
                      :headers="header_ticket"
                      :items="ticket.watcher"
                      :items-per-page="10"
                      dense
                      @click:row="clickTicket"
                    >
                      <template v-slot:item.priority="{ item }">
                        <v-chip :color="getPriorityTicket(item.priority).color" dark small>
                          {{ getPriorityTicket(item.priority).name }}
                        </v-chip>
                      </template>
                      <template v-slot:item.whom="{ item }">
                        {{ getWhom(item) }}
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-tab-item>
          </v-tabs>

        </v-card>
      </v-col>

    </v-row>
<!--    <v-btn @click="$store.commit('rn/VIEW_PARTNER', 101)">Test</v-btn>-->
  </v-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data: () => ({
    task_tab: null,
    prj_tab: null,
    ticket_tab: null,
    common_tab: null,
    headers_prj: [
      { value: 'id', hidden: true },
      { text: 'Название проекта', value: 'name', width: '45%' },
      { text: 'Срок', value: 'deadline_dt' },
      { text: 'Категория', value: 'category' },
      { text: 'Статус', value: 'status' },
      { text: 'Заказчик', value: 'customer' }
    ],
    headers_prj_customer: [
      { value: 'id', hidden: true },
      { text: 'Название проекта', value: 'name', width: '45%' },
      { text: 'Срок', value: 'deadline_dt' },
      { text: 'Категория', value: 'category' },
      { text: 'Статус', value: 'status' },
      { text: 'Рук.проекта', value: 'executor' }
    ],
    headers_prj_sub: [
      { value: 'id', hidden: true },
      { text: 'Название проекта', value: 'name', width: '40%' },
      { text: 'Срок', value: 'deadline_dt' },
      { text: 'Категория', value: 'category' },
      { text: 'Статус', value: 'status' },
      { text: 'Рук.проекта', value: 'executor' },
      { text: 'Сотрудники', value: 'members' }
    ],
    headers_task: [
      { value: 'number', hidden: true },
      { text: 'Название задачи', value: 'name', width: '50%' },
      { text: 'Срок', value: 'deadline_dt' },
      { text: 'Приоритет', value: 'priority' },
      { text: 'Статус', value: 'status' },
      { text: 'Категория', value: 'category_text' },
      { text: 'Заказчик', value: 'customer.short_name' }
    ],
    headers_task_exe: [
      { value: 'number', hidden: true },
      { text: 'Название задачи', value: 'name', width: '50%' },
      { text: 'Срок', value: 'deadline_dt' },
      { text: 'Приоритет', value: 'priority' },
      { text: 'Статус', value: 'status' },
      { text: 'Категория', value: 'category_text' },
      { text: 'Исполнитель', value: 'executor.short_name' }
    ],
    header_ticket: [
      { value: 'number', hidden: true },
      { text: 'Название заявки', value: 'name', width: '40%' },
      { text: 'Срок', value: 'deadline_dt' },
      { text: 'Приоритет', value: 'priority' },
      { text: 'Статус', value: 'status' },
      { text: 'Исполнитель', value: 'whom' },
      { text: 'Объект', value: 'facility.name' },
      { text: 'Контрагент', value: 'partner.name' }
      // { text: 'Конт. лицо', value: 'customer.short_name' }
    ],
    tasks: {
      whom: [],
      executor: [],
      customer: [],
      watcher: []
    },
    projects: {
      participate: [],
      whom: [],
      customer: [],
      executor: [],
      sub: []
    },
    ticket: {
      whom: [],
      executor: [],
      watcher: []
    },
    prioritiesTicket: [
      { value: 5, name: 'Авария', color: 'red' },
      { value: 10, name: 'Высокий', color: 'orange' },
      { value: 20, name: 'Обычный', color: 'green' },
      { value: 30, name: 'Низкий', color: 'green' }
    ],
    prioritiesTask: [
      { value: 10, name: 'Высокий', color: 'red' },
      { value: 20, name: 'Повышенный', color: 'orange' },
      { value: 30, name: 'Нормальный', color: 'green' }
    ]
  }),
  mounted () {
    this.getData()
  },
  created () {
    this.$eventHub.$on('refresh', this.getData)
  },
  destroyed () {
    this.$eventHub.$off('refresh', this.getData)
  },
  computed: {
    visibleTaskPanel: function () {
      return this.tasks.whom.length === 0 &&
        this.tasks.customer.length === 0 &&
        this.tasks.executor.length === 0 &&
        this.tasks.watcher.length === 0
    },
    visibleProjectPanel: function () {
      return this.projects.participate.length === 0 &&
        this.projects.whom.length === 0 &&
        this.projects.customer.length === 0 &&
        this.projects.executor.length === 0 &&
        this.projects.sub.length === 0
    },
    visibleTicketPanel: function () {
      return this.ticket.whom.length === 0 &&
        this.ticket.executor.length === 0 &&
        this.ticket.watcher.length === 0
    }
  },
  methods: {
    async getData () {
      const data = await this.$store.dispatch('dashboard/GET_DASHBOARD')
      this.projects.participate = data.projects.participate
      this.projects.whom = data.projects.whom
      this.projects.customer = data.projects.customer
      this.projects.executor = data.projects.executor
      this.projects.sub = data.projects.sub
      this.tasks.whom = data.task.whom
      this.tasks.executor = data.task.executor
      this.tasks.customer = data.task.customer
      this.tasks.watcher = data.task.watcher
      this.ticket.whom = data.ticket.whom
      this.ticket.executor = data.ticket.executor
      this.ticket.watcher = data.ticket.watcher
    },
    clickProject (event) {
      this.$router.push({ path: `/projects/${event.id}/view` })
    },
    clickTask (event) {
      this.$router.push({ path: `/tasks/${event.id}/view` })
    },
    clickTicket (event) {
      this.$router.push({ path: `/tickets/${event.id}/view` })
    },
    getPriority (val) {
      return this.prioritiesTask.find(priority => priority.value === val)
    },
    getWhom (item) {
      if (item.whom) {
        return item.whom.short_name
      } else if (item.dep) {
        return item.dep.name
      } else {
        return '-'
      }
    },
    getPriorityTicket (val) {
      return this.prioritiesTicket.find(priority => priority.value === val)
    },
    expiredTask (item) {
      if (this.$moment().valueOf() > this.$moment(item.deadline_dt, 'DD.MM.YYYY').valueOf()) {
        return 'red lighten-2'
      }
    }
  }
}
</script>

<style scoped>

</style>
